import { Component, Input } from '@angular/core';
import { ClientCreditHistoryItem } from 'src/app/services/credits/credits.service';
import { RouterLink } from '@angular/router';
import { PayeeIconButtonComponent } from '../../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-credit-history-item',
  templateUrl: './credit-history-item.component.html',
  styleUrls: ['./credit-history-item.component.scss'],
  imports: [RouterLink, PayeeIconButtonComponent, MatIcon, DatePipe],
})
export class CreditHistoryItemComponent {
  @Input({ required: true }) item!: ClientCreditHistoryItem;
}
